import clsx from 'clsx';
import './copyright-button.scss';
export default function CRButton({
  onClick,
  isHide,
}: {
  onClick: () => void;
  isHide: boolean;
}) {
  return (
    <div className="cr_bt_wrapper" onClick={onClick}>
      <div
        className={clsx([
          'arrow transition-all duration-300 ',
          !isHide && 'rotate-180',
        ])}
      ></div>
    </div>
  );
}
